import { useEffect } from "react";

const APPLE_SDK_SRC =
  "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";

/**
 * Return URL registrada en el Services ID de Apple Developer
 * (cl.openmaticmarket.webstore). Con usePopup:true, Apple carga esta página
 * dentro del popup y usa el SDK de Apple aquí para relayar el resultado del
 * login al window.opener vía postMessage — no necesita renderizar nada, solo
 * cargar el mismo script que Login.jsx.
 */
export const AppleCallbackPage = () => {
  useEffect(() => {
    if (!document.querySelector(`script[src="${APPLE_SDK_SRC}"]`)) {
      const script = document.createElement("script");
      script.src = APPLE_SDK_SRC;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return null;
};
